import React from 'react';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DOMPurify from 'dompurify';

const MyCKEditor = ({field}) => {
    return (<div>
            <style>
                {`
                    .form-error .ck-editor__editable{
                        border-color:red!important;
                    }
                    .form-error .ck-editor__editable:not(:focus){
                        background-color:rgba(255, 0, 0, 0.1);
                    }
                    
                    .ck-editor__editable ul {
                        list-style-type: square; /* Changes bullet style */
                        padding-left: 20px;
                        margin: 10px 0;
                    }

                    .ck-editor__editable ol {
                        list-style-type: upper-roman; /* Changes numbering style */
                        padding-left: 20px;
                        margin: 10px 0;
                    }

                    .ck-editor__editable li {
                        line-height: 1.5;
                        color: #333;
                    }
                    
                    .ck-editor__editable p {
                        margin-top:14.4px;
                    }
                    
                    .ck-powered-by{
                        display:none
                    }
                `}
            </style>
            <CKEditor
                editor={ClassicEditor}
                data={field.value} // Set initial data
                config={{
                    language: 'de',
                    toolbar: {
                        items: ['undo', 'redo', 'bold', 'italic', 'bulletedList', 'numberedList', 'removeFormat'],
                    },
                    htmlSupport: {
                        allow: [
                            { name: 'p', attributes: true },
                            { name: 'strong', attributes: true },
                            { name: 'em', attributes: true },
                            { name: 'ul', attributes: true },
                            { name: 'ol', attributes: true },
                            { name: 'li', attributes: true },
                        ],
                    },
                    basicEntities: false
                }}
                onChange={(event, editor) => {
                    let data = editor.getData();
                    data = DOMPurify.sanitize(data, {
                        ALLOWED_TAGS: ['p', 'strong', 'em', 'ul', 'ol', 'li', 'br'], // Allow specific tags
                        ALLOWED_ATTR: [] // Remove all attributes
                    });

                    field.onChange(data); // Update the form state with sanitized content
                }}
            />
        </div>
    );
};

export default MyCKEditor;
